/* eslint-disable @typescript-eslint/indent */
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { ReactComponent as CheckMark } from 'assets/icons/checkmark.svg';

interface Props {
  color?: string;
  completed: boolean;
  current: boolean;
  expanded?: boolean;
  icon?: ReactNode;
  substep?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
}

type StatusProps = {
  current: boolean;
  complete: boolean;
};

const StepIcon = ({ current, completed, isFirst, isLast }: Props) => {
  return (
    <Container>
      {completed && (
        <CheckBoxWrapper>
          <CheckMark />
        </CheckBoxWrapper>
      )}
      {!isFirst && <TopConnector />}
      <Circle current={current} complete={completed} />
      {!isLast && <BottomConnector />}
    </Container>
  );
};

export default StepIcon;

const Container = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
`;

const Circle = styled.div<StatusProps>`
  width: 12px;
  height: 12px;
  background-color: ${({ current, complete }: StatusProps) => {
    if (complete) {
      return themes.colors.pinkLight;
    } else if (current) {
      return themes.colors.KBNight;
    }
    return themes.colors.pink;
  }};
  border: 4px solid ${themes.colors.pinkLight};
  border-radius: 50%;
  box-sizing: content-box;
`;

const TopConnector = styled.div`
  height: 10px;
  width: 6px;
  position: absolute;
  left: 7px;
  bottom: 20px;
  background-color: ${themes.colors.pinkLight};
`;

const BottomConnector = styled.div`
  height: 10px;
  width: 6px;
  position: absolute;
  left: 7px;
  background-color: ${themes.colors.pinkLight};
`;

const CheckBoxWrapper = styled.div`
  position: absolute;
  position: absolute;
  right: -2px;
  bottom: -7px;
`;
